<template>
  <v-select
    label="Source Type"
    v-model="type"
    :items="items"
    item-text="displayText"
    chips
    small-chips
    :clearable="false"
    deletable-chips
    hide-details
    multiple
    class="mb-4"
    @change="handleOnChange"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="selectAllItems">
        <v-list-item-action>
          <v-icon :color="type.length > 0 ? 'primary' : ''">
            {{ itemsAllIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Select All
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";

import { SOURCE_METADATA_TYPE } from "@/common/constants/search";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterSourceType",
  props: {
    selected: {
      type: Array,
    },
    counts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      type: [],
      items: [],
      availableItems: SOURCE_METADATA_TYPE,
    };
  },
  computed: {
    itemsSelectedAll() {
      return this.type.length === this.items.length;
    },
    itemsSelectedSome() {
      return this.type.length > 0 && !this.itemsSelectedAll;
    },
    itemsAllIcon() {
      if (this.itemsSelectedAll) {
        return "mdi-close-box";
      }
      if (this.itemsSelectedSome) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    getItems() {
      const arr = lodashCloneDeep(this.availableItems);
      if (this.counts) {
        arr.forEach((item) => {
          Object.keys(this.counts).forEach((key) => {
            if (key === item.value) {
              item.count = this.counts[key];
              item.displayText = `${item.text} (${item.count})`;
            }
          });
        });
      }
      this.items = arr;
    },
    handleOnChange() {
      this.$emit(EMITTED_ACTIONS.CHANGE, [
        {
          type: "type",
          value: this.type,
        },
      ]);
    },
    selectAllItems() {
      this.$nextTick(() => {
        this.type =
          this.type.length === this.items.length
            ? []
            : this.items.map((x) => x.value);
        this.handleOnChange();
      });
    },
  },
  watch: {
    selected: {
      handler() {
        this.getItems();
        if (this.selected && this.selected.length) {
          const selected = [];
          this.availableItems.forEach((item) => {
            if (this.selected.includes(item.value)) {
              selected.push(item);
            }
          });
          this.type = selected;
        }
      },
      deep: true,
      immediate: true,
    },
    counts: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    reset: {
      handler() {
        this.type = [];
      },
    },
  },
};
</script>

<style>
.search-box.theme--light.v-text-field--solo-inverted.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  input {
  color: rgba(0, 0, 0, 0.6);
}
</style>
